export default __webpack_public_path__ + "static/media/ctry.b3db5640.png";